import "./Footer.css";
import logo from "./blackdoorLogo2Edited.jpg";

export default function Footer(props) {
  return (
    <>
      <div className="footer">
        <div className="company-details">
          <div className="logo">
            <img className="footer-logo" src={logo} alt="BlackDoor logo" />
            BlackDoor
          </div>
          <p className="">© 2024 BlackDoor. All Rights Reserved</p>
          {/* <p className="">Address: D-78, Sector-x, Bangalore - 2000012</p> */}
          <p className="">Email: support@blackdoorapps.com</p>
        </div>

        <div className="company-policy">
          <p className="policy-title">POLICY</p>
          <a
            href="https://sites.google.com/view/grabnedit-terms-of-use/home"
            target="_blank"
            rel="noreferrer"
          >
            <p>Terms & Conditions</p>
          </a>
          <a
            href="https://sites.google.com/view/grabnedit-privacy-policy/home"
            target="_blank"
            rel="noreferrer"
          >
            <p>Privacy Policy</p>
          </a>
        </div>
      </div>
    </>
  );
}
